var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReply2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7494 18.9443H2.24992C1.00946 18.9443 0 17.9349 0 16.6944V10.6946C0 10.2799 0.335238 9.94466 0.749973 9.94466C1.16471 9.94466 1.49995 10.2799 1.49995 10.6946V16.6944C1.49995 17.1084 1.83593 17.4444 2.24992 17.4444H15.7494C16.1634 17.4444 16.4994 17.1084 16.4994 16.6944V6.19479C16.4994 5.7808 16.1634 5.44482 15.7494 5.44482H13.4995C13.0848 5.44482 12.7495 5.10958 12.7495 4.69484C12.7495 4.28011 13.0848 3.94487 13.4995 3.94487H15.7494C16.9899 3.94487 17.9994 4.95433 17.9994 6.19479V16.6944C17.9994 17.9349 16.9899 18.9443 15.7494 18.9443Z",
    fill: "#B9C4E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.18728 3.94486H5.99979V1.50745C5.99979 1.27796 5.86029 1.07172 5.6473 0.986219C5.43431 0.898472 5.19057 0.95172 5.03232 1.11671L0.157494 6.17903C-0.0524981 6.39728 -0.0524981 6.74151 0.157494 6.95976L5.03232 12.0221C5.19132 12.1871 5.43656 12.2403 5.6473 12.1533C5.86029 12.0678 5.99979 11.8616 5.99979 11.6321V9.19468H6.89075C9.25017 9.19468 11.3703 10.5049 12.4248 12.6146L12.4346 12.6333C12.5306 12.8275 12.7278 12.9445 12.937 12.9445C12.9798 12.9445 13.0233 12.9393 13.066 12.9288C13.3203 12.8695 13.4995 12.6431 13.4995 12.3821V11.2571C13.4995 7.22525 10.2191 3.94486 6.18728 3.94486Z",
    fill: "#B9C4E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply2);
export default __webpack_public_path__ + "static/media/reply2.ecbd469137c0bbbeb41d3a37605fead6.svg";
export { ForwardRef as ReactComponent };